import { render, staticRenderFns } from "./SlideContent.vue?vue&type=template&id=22cf0c6e&scoped=true&"
import script from "./SlideContent.vue?vue&type=script&lang=js&"
export * from "./SlideContent.vue?vue&type=script&lang=js&"
import style0 from "./SlideContent.vue?vue&type=style&index=0&id=22cf0c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf0c6e",
  null
  
)

export default component.exports